import { ConsentEntityType } from "./ConsentRequestBody";

export default class ConsentModel {
  public consentId: string = "";
  public entityId: string | null = null;
  public entityType: ConsentEntityType | null = null;
  public content: string | null = null;
  public consentedAt: string = "";
}
